import { render, staticRenderFns } from "./customFixedAssetNo.vue?vue&type=template&id=f88a5af2&scoped=true&"
import script from "./customFixedAssetNo.vue?vue&type=script&lang=js&"
export * from "./customFixedAssetNo.vue?vue&type=script&lang=js&"
import style0 from "./customFixedAssetNo.vue?vue&type=style&index=0&id=f88a5af2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f88a5af2",
  null
  
)

export default component.exports